module.exports = __webpack_public_path__ + "static/about-bg-mobile-048aae176bcdaa728f5da40a0211382a.jpg";